module.exports = __webpack_public_path__ + "img/skill-3.e66a267b.svg";